import { createListLoadingReducer } from './utils';
import { BookingReportOption } from '@/types';

export default createListLoadingReducer<BookingReportOption>('BOOKING_REPORT_OPTIONS');
